<template>
  <div class="card">
    <h4>Informations de votre organisation</h4>
    <p>
      Retrouvez toutes les informations de votre organisation. Vous pouvez les
      modifier à tout moment.
    </p>
    <Form
      class="form-container"
      @submit="edit"
      v-slot="{ errors, meta, isSubmitting }"
    >
      <div class="input-inline">
        <VField
          placeholder="Yuzu"
          name="company"
          rules="required|min:2|max:50"
          v-model="state.formValues.name"
          :label="$t('form.register.company')"
          :class="{
            invalid: Object.keys(errors)[0] === 'company',
          }"
        />
        <VField
          placeholder="FR32123456789"
          name="vat_number"
          v-model="state.formValues.vat_number"
          rules="required|vat"
          :label="$t('form.register.vat_number')"
          :class="{ invalid: Object.keys(errors)[0] === 'vat_number' }"
        />
      </div>
      <div class="input-inline">
        <VField
          placeholder="4 Rue du Pont Neuf"
          name="address"
          v-model="state.formValues.address"
          rules="required|min:2|max:256"
          :label="$t('form.register.address')"
          :class="{ invalid: Object.keys(errors)[0] === 'address' }"
        />
        <VField
          placeholder="Paris"
          name="city"
          v-model="state.formValues.city"
          rules="required|textOnly|min:2|max:128"
          :label="$t('form.register.city')"
          :class="{ invalid: Object.keys(errors)[0] === 'city' }"
        />
      </div>
      <div class="input-inline">
        <VField
          placeholder="75001"
          name="postalCode"
          v-model="state.formValues.postal_code"
          rules="required|postalCode"
          :label="$t('form.register.postalCode')"
          :class="{ invalid: Object.keys(errors)[0] === 'postalCode' }"
        />

        <div class="input-wrapper">
          <label v-text="$t('form.register.country')" for="country" />
          <v-select
            id="country"
            name="country"
            :placeholder="$t('form.register.selectCountry')"
            v-model="state.formValues.country"
            :clearable="false"
            :required="true"
            :options="['France', 'Belgique', 'Luxembourg']"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!state.formValues.country"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <div style="padding: 8px 0">
                Pas de résultat {{ searching ? ` pour ${search}` : "" }}.
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="input-inline">
        <div
          v-if="Object.keys(errors).length > 0"
          class="form-error"
          v-text="Object.values(errors)[0]"
        />
        <Button
          class="primary"
          label="Enregistrer les modifications"
          :type="!isDisabled(meta.valid) && !isSubmitting ? 'submit' : 'button'"
          :loading="isSubmitting"
          :disabled="isDisabled(meta.valid)"
        />
      </div>
    </Form>
  </div>
</template>

<script setup>
import { Form } from "vee-validate";
import { reactive, computed } from "vue";
import { useCompanyStore } from "@/stores/company.js";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";

const toast = useToast();

const route = useRoute();

const { currentCompany, editCompany } = useCompanyStore();

const state = reactive({
  formValues: { ...currentCompany },
});

const valuesAreModified = computed(() => {
  return JSON.stringify(state.formValues) !== JSON.stringify(currentCompany);
});

function isDisabled(isValid) {
  return !isValid || !state.formValues.country || !valuesAreModified.value;
}

async function edit() {
  const resp = await editCompany(route.params.companyId, state.formValues);

  if (resp.code) {
    toast.error(getError(resp.key));
  } else {
    toast.success(
      "Les informations de votre organisation ont bien été modifiées."
    );
  }
}
</script>
